import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";
const useStyles = makeStyles((theme) => {
  return {
    mainAboutusContainer: {
      paddingLeft: theme.spacing(myTheme.padding.left + 3.4),
      paddingRight: theme.spacing(myTheme.padding.right + 3.4),
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        //marginLeft:'15%'
      },
    },
    bCrumbLink: {
      "text-decoration": "none",
      color:'grey',
      "&:hover": {
        color: "black",
        "text-decoration": "none",
      },
    },
    FiltersGrid: {
      //   backgroundColor:'silver'
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        display:'none'
      },
    },
    categoriesFilters: {
      border: "0.2px solid #e5e5e5",
      borderRadius: 2,
    },
    categoriesFilterHeading: {
      borderLeft: "3.5px solid " + myTheme.palette.primary.main,
    },
    categoreisFilters: {
      borderTop: "0.3px solid #e5e5e5",
    },
    categoriesList: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    slider: {
      // width: 280,
      paddingTop: 15,
    },
    filtersMainBox: {
      border: "0.2px solid #e5e5e5",
      borderRadius: 2,
      marginTop: 20,
    },
    modalMainBox:{
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        padding:20,
        paddingTop:12,
        paddingBottom:8
      },
    },
    FiltersMobileBtn:{
      [theme.breakpoints.up(myTheme.breakpoints.values.md)]: {
        visibility:'hidden',
        display:'none'
      }
    },
    sortByText:{
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        fontSize:13
      },
    },
    modalStyle1:{
      position:'absolute',
      top:'20%',
      left:'10%',
      overflow:'scroll',
      height:'85%',
      display:'block',
      backgroundColor:'white',
      borderRadius:'10px',
      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
      margin:'10%'
    },
    priceCateBrandMainDiv: {
      padding: 10,
      borderTop:'0.2px solid #e5e5e5'
    },
    priceFilterBox: {
      padding: 10,
      paddingBottom: 15,
      borderBottom: "0.2px solid #e5e5e5",
    },
    onSaleBox: {
      padding: 10,
      paddingTop: 23,
      paddingBottom: 20,
      borderBottom: "0.2px solid #e5e5e5",
    },
    dateRangeBox: {
      padding: 10,
      paddingTop: 18,
    },
    containerDate: {
      display: "flex",
      flexWrap: "wrap",
      paddingTop: 8,
      paddingBottom: 23,
    },
    textFieldDate: {
      width: 200,
    },
    BrandSelectBox: {
      padding: 10,
      paddingTop: 25,
      borderTop: "0.2px solid #e5e5e5",
    },
    brandsList: {
      padding: 0,
    },
    listItem: {
      display: "flex",
      paddingBottom: 8,
      color: "#666",
    },
    applyFiltersBtn: {
      backgroundColor: myTheme.palette.primary.main,
      color: myTheme.palette.primary.contrastText,
      letterSpacing: 1,
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
        color: myTheme.palette.primary.contrastText,
      },
      marginTop: 20,
      width: "100%",
    },
    ClearFiltersBtn: {
      backgroundColor: "#e5e5e5",
      color: myTheme.palette.secondary.main,
      letterSpacing: 1,
      "&:hover": {
        backgroundColor: "silver",
      },
      marginTop: 8,
      width: "100%",
    },
    ProductsHeadingBox:{
      padding:10,
      paddingTop:5,
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        paddingLeft:1
      },
    },
    mainProductsGrid:{
      paddingLeft:20,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingLeft:0
      },
    },
    resultsAndSortBox:{
      display:'flex',
      justifyContent:'space-between',
      alignItems:'center',
      color:'#666',
      borderBottom: "0.2px solid #e5e5e5",
      paddingBottom:10,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        flexDirection:'column',
        alignItems:'flex-start',
        marginTop:5
      },
    },
    formSorting: {
      margin: theme.spacing(1),
    },
    productsMainGrid:{
      paddingLeft:6,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingLeft:0,
        justifyContent:'center'
      },
    },
    loadMoreBtn:{
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      margin:25,
      marginLeft:10
    }
  };
});

export default useStyles;
